import { Injectable } from '@angular/core';
import { Loggable } from '@services/strategy-pattern-login/loggable';
import { OAuthService as OAuth2Service  } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';
import { Credentials, IAuthStrategy, Token, UsernameAndPassword, UsernameAndPasswordAndProfile } from '../interfaces/auth-strategy.interface';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class IAMAuthService implements IAuthStrategy {
  constructor(private oauth: OAuth2Service) {}



  async init(config?: any): Promise<void> {
      this.oauth.configure({
        issuer: environment.IDENTITY_PROVIDER_URL,
        redirectUri: environment.POST_LOGIN_REDIRECT_URL,
        clientId: environment.CLIENT_ID,
        postLogoutRedirectUri: environment.POST_LOGOUT_REDIRECT_URL,
        useSilentRefresh: false,
        responseType: 'code',
        scope: 'openid profile email offline_access',
        showDebugInformation: false,        
        ...config
      });
      this.oauth.setStorage(sessionStorage);
    await this.oauth.loadDiscoveryDocument(); // carrega endpoints do IdP
    await this.oauth.tryLoginCodeFlow();      // tenta finalizar o fluxo de code+PKCE
    // Se quiser forçar login automático quando não autenticado:
    // if (!this.isLoggedIn()) await this.login();
  }

  // login(returnUrl?: string) {
  //   this.oauth.initCodeFlow(returnUrl ? encodeURIComponent(returnUrl) : undefined);
  // }

  login(creadentials?: any, returnUrl?): Observable<any> {
    this.oauth.initCodeFlow(returnUrl ? encodeURIComponent(returnUrl) : undefined);
    return of([])
  }
  getTokenApi?(): string {
    return this.oauth.getAccessToken()    // throw new Error('Method not implemented.');
  }
  getTokenWs?(): string {
    throw new Error('Method not implemented.');
  }
  setTokenApi?(value: string) {
    throw new Error('Method not implemented.');
  }
  setTokenWs?(value: string) {
    throw new Error('Method not implemented.');
  }
  getBrokerAccount?(): string {
    throw new Error('Method not implemented.');
  }
  getRefreshToken?(): string {
    throw new Error('Method not implemented.');
  }
  setCurrentUser?(user: any) {
    throw new Error('Method not implemented.');
  }
  getCurrentUser?() {
    return this.oauth.loadUserProfile();

  }

  logout() {
    this.oauth.logOut(); // ou this.oauth.revokeTokenAndLogout();
  }

  isLoggedIn(): boolean {
    return !!this.oauth.getAccessToken();
  }

  get accessToken(): string | null {
    return this.oauth.getAccessToken() || null;
  }

  get identityClaims(): any {
    return this.oauth.getIdentityClaims();
  }

  loginO(username: string, password: string, profile?: any) {
    throw new Error('Method not implemented.');
  }
  brokerServiceLogin(username: string, password: string, broker: string) {
    throw new Error('Method not implemented.');
  }
  brokerServiceLogout() {
    throw new Error('Method not implemented.');
  }
  brokerServiceInternalLogout() {
    throw new Error('Method not implemented.');
  }
  recoverPassword(email: string, type: number, client?: boolean) {
    throw new Error('Method not implemented.');
  }
  changePassword(token: string, type: number, newPassword: string, broker: string, product?: string, recoverType?: string) {
    throw new Error('Method not implemented.');
  }
  difusionChangePassword(login: string, oldPassword: string, newPassword: string, isPasswordExpired: boolean, recoverType?: number) {
    throw new Error('Method not implemented.');
  }
  clientRegisterSimulator(username: string, password: string) {
    throw new Error('Method not implemented.');
  }
  isTokenExpired() {
    throw new Error('Method not implemented.');
  }
  refresh(): Observable<any> {
    return new Observable(observer => {
      this.oauth.refreshToken()
        .then(result => {
          observer.next(result);
          observer.complete();
        })
        .catch(error => observer.error(error));
    });
  }
  resetSignature(signature: string, newSignature: string) {
    throw new Error('Method not implemented.');
  }
  forgotSignature() {
    throw new Error('Method not implemented.');
  }
  advisorInfo(login?: string) {
    throw new Error('Method not implemented.');
  }
  advisorChangePassword(currentPassword: string, newPassword: string, guid?: string, advisorId?: number) {
    throw new Error('Method not implemented.');
  }
  loginToken(token: string) {
    throw new Error('Method not implemented.');
  }
  loginAuth(code: string, login: any, second_auth_option: string, answer: string, username?: string, password?: string) {
    throw new Error('Method not implemented.');
  }
  loginWS(guidUser?: string) {
    throw new Error('Method not implemented.');
  }
  info() {
    throw new Error('Method not implemented.');
  }
  validateTokenAdapter() {
    throw new Error('Method not implemented.');
  }
}
